import React, { useEffect, useState } from 'react';

import { RailcardsForm, Spinner } from '@silverrailtech/srtlibrary';

import { getCustomerAccountData } from '../../../../api';
import ExtendedSnackbar from '../../../../components/ExtendedSnackbar/ExtendedSnackbar';
import useAuth from '../../../../hooks/useAuth';

// TODO - Remove and replace with real API call. This is temporary
const mockRailcards = [
	{
		value: 'UK_CAMBRIAN',
		name: 'Cambrian Railcard',
	},
	{
		value: 'UK_CLUB50WEB_GA',
		name: 'Club 50 Web - Greater Anglia',
	},
	{
		value: 'UK_CLUB50WEB_SR',
		name: 'Club 50 Web - ScotRail',
	},
	{
		value: 'UK_COTSWOLD',
		name: 'Cotswold Line Railcard',
	},
	{
		value: 'UK_CUMBRIACARD',
		name: 'MyCumbria Card',
	},
	{
		value: 'UK_DALES',
		name: 'Dales Railcard',
	},
	{
		value: 'UK_DISABILITY',
		name: 'Disabled Persons Railcard',
	},
	{
		value: 'UK_ESKVALLEY',
		name: 'Esk Valley Railcard',
	},
	{
		value: 'UK_HEARTWALES',
		name: 'Heart of Wales Railcard',
	},
	{
		value: 'UK_HIGHLAND_NS',
		name: 'Highland Railcard',
	},
	{
		value: 'UK_HIGHLAND_WS',
		name: 'Highland Railcard : West Scotland',
	},
	{
		value: 'UK_PEMBROKESHIRE',
		name: 'Pembrokeshire Railcard',
	},
	{
		value: 'UK_SCOTTISH_YOUTH',
		name: 'Young Scot Card (16-18 Only)',
	},
	{
		value: 'UK_SY_DISABLED',
		name: 'SY Concession Disabled',
	},
	{
		value: 'UK_SY_SENIOR',
		name: 'SY Concession Senior',
	},
	{
		value: 'UK_SY_STUDENT',
		name: 'South Yorkshire 16-18 Zoom Travel Pass',
	},
	{
		value: 'UK_U25_ADVANCE',
		name: 'Under 25 Advance',
	},
	{
		value: 'UK_VL_SENIOR',
		name: 'Valleys Senior Railcard',
	},
	{
		value: 'UK_VL_STUDENT',
		name: 'Valleys Student Railcard',
	},
	{
		value: 'UK_WY_DISABLED',
		name: 'West Yorkshire Disabled Concessionary Discount',
	},
	{
		value: 'UK_WY_SENIOR',
		name: 'WY Senior Concession Disc',
	},
	{
		value: 'UK_WY_STUDENT',
		name: 'WY Under 19 PhotoCard',
	},
	{
		value: 'UK_TFW_18',
		name: '18 Saver - Transport for Wales',
	},
	{
		value: 'UK_TFW_STUDENT',
		name: 'Student Railcard - Transport for Wales',
	},
	{
		value: 'UK_TFW_BUS_PASS',
		name: 'TfW Concessionary Bus Pass',
	},
	{
		value: 'UK_TFW_ANNUAL_SEASON',
		name: 'TfW Annual Season Railcard',
	},
	{
		value: 'UK_YOUTH_16_17',
		name: '16-17 Saver',
	},
	{
		value: 'UK_YOUTH',
		name: '16-25 Railcard',
	},
	{
		value: 'UK_YOUNG_ADULT',
		name: '26-30 Railcard',
	},
	{
		value: 'UK_FAMILY_FRIENDS',
		name: 'Family & Friends Railcard',
	},
	{
		value: 'UK_SENIOR',
		name: 'Senior Railcard',
	},
	{
		value: 'UK_CHILD_DISABILITY',
		name: 'Disabled Child Railcard',
	},
	{
		value: 'UK_HM_ARMED_FORCES',
		name: 'HM Forces Railcard',
	},
	{
		value: 'UK_ANNUAL_GOLD',
		name: 'Annual Gold Card',
	},
	{
		value: 'UK_NETWORK',
		name: 'Network Railcard',
	},
	{
		value: 'UK_JOBCENTRE_PLUS',
		name: 'Jobcentre Plus Travel Discount Card',
	},
	{
		value: 'UK_TWO_TOGETHER',
		name: 'Two Together Railcard',
	},
	{
		value: 'UK_GROUPSAVE',
		name: 'GroupSave',
	},
	{
		value: 'UK_CLUB50',
		name: 'Club 50',
	},
	{
		value: 'UK_VETERAN',
		name: 'Veterans Railcard',
	},
	{
		value: 'UK_DEVONCORNWALL',
		name: 'Devon & Cornwall Railcard',
	},
];

const RailCards = () => {
	const { getAuthHeaders, accountId } = useAuth();
	const [formData, setFormData] = useState([]);
	const [isPending, setIsPending] = useState(true);
	const [error, setError] = useState('');

	useEffect(() => {
		if (accountId) {
			getCustomerAccountData(
				null,
				getAuthHeaders(),
				`/${accountId}/reductioncards`,
				() => {
					setIsPending(false);
					setError('Failed to load railcards');
				},
				(data) => {
					setFormData(data);
					setIsPending(false);
				},
			);
		}
	}, [accountId, getAuthHeaders]);

	const props = {
		options: mockRailcards,
		formData,
		showEditButton: false,
	};
	return (
		<>
			<RailcardsForm {...props} />
			<ExtendedSnackbar
				id="srtRailCardSnackBar"
				open={error !== ''}
				message={error}
				onClose={() => setError('')}
			/>
			{isPending && <Spinner />}
		</>
	);
};

export default RailCards;
